<template>
  <div class="dygpt-layer">
    <caseheader v-if="casetype != 3"></caseheader>
    <iframe id="myIframe" v-show="showiframe" :src="dygptUrl + version" style="width: 100%;border: 0;"
            :style="{ height: casetype == 3 ? '99.8%' : 'calc(99.8% - 60px)' }"></iframe>
  </div>
</template>

<script>
import Caseheader from '@/components/layout/caseheader.vue';
export default {
  name: '',
  components: { Caseheader },
  props: {},
  data () {
    return {
      casetype: 3,
      showiframe: false,
      // dygptUrl: dygptUrl,
      WebUrl: WebUrl,
      version: Math.random().toString(36).substring(2, 15),
    }
  },
  computed: {
    dygptUrl () {
      let suiji = Math.random().toString(36).substring(2, 15)
      let type = sessionStorage.getItem('casetype')
      let caseno = sessionStorage.getItem('caseno')
      let routename = this.$route.query.routename || 'zhinengkefu'
      if (type == 1 || type == 2) {
        // let url = window.dygptUrl + sessionStorage.getItem('dygptaccount') + '&type=' + type + '&caseno=' + caseno
        let dygptaccount
        if (type == 1) {
          dygptaccount = sessionStorage.getItem('dygptaccount') + '_AL'
        } else if (type == 2) {
          dygptaccount = sessionStorage.getItem('dygptaccount') + '_GZL'
        }
        // let url = window.dygptUrl + '?u=' + dygptaccount + '&p=1234&type=' + type + '&caseno=' + caseno + '&routename=' + routename + '&v=' + suiji
        let url = window.dygptUrl + '?u=' + dygptaccount + '&p=1234&type=' + type + '&caseno=' + caseno + '&routename=' + routename
        return url
      } else {
        // let url = window.dygptUrl + sessionStorage.getItem('dygptaccount') + '&type=3'
        // let url = window.dygptUrl + '?u=' + sessionStorage.getItem('dygptaccount') + '&p=1234&type=3' + '&v=' + suiji
        let url = window.dygptUrl + '?u=' + sessionStorage.getItem('dygptaccount') + '&p=1234&type=3'
        return url
      }

    }
  },
  watch: {},
  created () {
    this.casetype = sessionStorage.getItem('casetype') || 3

    this.load()

    // 1秒后强制刷新iframe
    setTimeout(() => {
      this.reloadIframe()
    }, 1000)

    if (!window.isGPTWindow) {
      // 监听 iframe 消息
      window.addEventListener("message", (event) => {
        if (event.data.action === "closeAndRedirect") {
          // 1. 移除 iframe
          const iframe = document.getElementById("myIframe");
          iframe.parentNode.removeChild(iframe);

          // 2. 跳转页面
          // window.location.href = WebUrl + event.data.url;
          // 新参数测试
          console.log("event.data.url>>>", event.data.url);
          let url = event.data.url
          let str1 = url.split('?')[0]
          let str2 = url.split('?')[1]
          let pjarr = str2.split('&')
          console.log("---pjarr---", pjarr);
          let type = pjarr[0]
          let caseno = pjarr[1]
          let routename = pjarr[2].split('routename=')[1]
          // let extend = pjarr[3].split('extend=')[1]
          let wanzhengUrl = WebUrl + str1 + '/' + routename + '?' + type + '&' + caseno
          console.log("wanzhengUrl>>>", wanzhengUrl);

          window.location.href = wanzhengUrl
        }
      });
    }
  },
  mounted () { },
  methods: {
    reloadIframe () {
      let version = Math.random().toString(36).substring(2, 15)
      let iframe = document.getElementById("myIframe");
      iframe.src = this.dygptUrl + '&v=' + version
    },
    //进入时模拟加载动画
    load () {
      const loading = this.$loading({
        lock: true,
        text: '努力加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.1)'
      })
      setTimeout(() => {
        loading.close()
        if (window.isGPTWindow) {
          var width = window.innerWidth;
          var height = window.innerHeight - 80;
          window.open(this.dygptUrl, '_blank', `width=${width},height=${height},left=0,top=130,location=no,resizable=no`);
        } else {
          this.showiframe = true
        }
      }, 2000);

    }
  }
}
</script>

<style scoped lang="less">
.dygpt-layer {
  width: 100%;
  height: 100%;
}
</style>
